// extracted by mini-css-extract-plugin
export default {"wrapper":"UserTags_wrapper__nbESb","tag":"UserTags_tag__2+GYp","single":"UserTags_single__MKpui","multiple":"UserTags_multiple__O5bAh","all_tags":"UserTags_all_tags__7CD5q"};